import {Box} from '@mantine/core';
import type React from 'react';
import {useEffect, useRef} from 'react';
import {GTAG_CMD_EVENT, GTAG_EVENT_NAMES} from '../../../config/constants/gtag';
import {useHandleLinkNotice} from '../../../shared/services/useHandleLinkNotice';
import {LinkNotice} from './LinkNotice';

export const LinkNoticePopup: React.FC = () => {
  const {linkNotice, isOpen, isShow, closePopup} = useHandleLinkNotice();
  const sentImpressionId = useRef<number | null>(null);

  useEffect(() => {
    if (
      linkNotice &&
      isShow &&
      isOpen &&
      sentImpressionId.current !== linkNotice.id
    ) {
      if (window?.gtag) {
        window.gtag(GTAG_CMD_EVENT, GTAG_EVENT_NAMES.IMP_LINK_NOTICE, {
          url: linkNotice.url,
          message: linkNotice.message,
        });
        sentImpressionId.current = linkNotice.id;
      }
    }
  }, [linkNotice, isShow, isOpen]);

  if (!isOpen || !isShow || !linkNotice) {
    return null;
  }

  return (
    <Box className="pc:bg-background-1 pc:pt-20 pc:my-0 mt-12 pc:mx-0 mx-16">
      <Box className="relative mx-auto pc:my-0 pc:max-w-[1200px] py-12 px-16 pc:mb-0 mb-[-20px] overflow-hidden items-center rounded-[8px] bg-white border-2 border-primary shadow-primary-glow">
        <Box className="absolute top-0 left-0 h-full w-[200px] bg-gradient-to-r from-primary/10 to-transparent animate-flow pointer-events-none" />
        <Box className="relative">
          <LinkNotice
            message={linkNotice.message}
            url={linkNotice.url}
            onClose={closePopup}
          />
        </Box>
      </Box>
    </Box>
  );
};
